"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeOnboardingStatus = exports.getOnboardingStatusVariant = exports.getOnboardingStatusTranslationKey = exports.getOnboardingStatusLabel = exports.getOnboardingStatusKey = void 0;
var _i18n = _interopRequireDefault(require("@/i18n"));
var _constants = require("@/config/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var STATUS_TRANSLATION_NAMESPACE = 'statuses.onboarding';
var STATUS_ALIASES = {
  started: 'started',
  em_processamento: 'started',
  completed: 'completed',
  concluido: 'completed',
  canceled: 'canceled',
  cancelado: 'canceled',
  downloaded: 'downloaded'
};
var normalizeOnboardingStatus = exports.normalizeOnboardingStatus = function normalizeOnboardingStatus(value) {
  if (!value) {
    return '';
  }
  return String(value).trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
};
var getOnboardingStatusKey = exports.getOnboardingStatusKey = function getOnboardingStatusKey(value) {
  var normalizedStatus = normalizeOnboardingStatus(value);
  return STATUS_ALIASES[normalizedStatus] || normalizedStatus;
};
var getOnboardingStatusTranslationKey = exports.getOnboardingStatusTranslationKey = function getOnboardingStatusTranslationKey(value) {
  var statusKey = getOnboardingStatusKey(value);
  return statusKey ? "".concat(STATUS_TRANSLATION_NAMESPACE, ".").concat(statusKey) : '';
};
var getOnboardingStatusLabel = exports.getOnboardingStatusLabel = function getOnboardingStatusLabel(value) {
  var fallbackLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!value) {
    return '--';
  }
  var translationKey = getOnboardingStatusTranslationKey(value);
  if (translationKey && _i18n.default.te(translationKey)) {
    return _i18n.default.t(translationKey);
  }
  return fallbackLabel || _constants.TYPES_STATUS_ONBOARDING[value] || value;
};
var getOnboardingStatusVariant = exports.getOnboardingStatusVariant = function getOnboardingStatusVariant(value) {
  if (!value) {
    return 'danger';
  }
  switch (getOnboardingStatusKey(value)) {
    case 'started':
      return 'warning';
    case 'completed':
    case 'downloaded':
      return 'success';
    case 'canceled':
      return 'danger';
    default:
      return 'info';
  }
};